import React, { useState } from "react"
const LocationForm=(props)=>{
    
    return(
        <React.Fragment>
          

<div className="row">
<div className="container">

<div className="col-12">
    <span className="d-inline-block text-white">  انتخاب لوکیشن </span>
    <input type="text" className="form-control d-inline-block"   pattern="[0-9]*" inputMode="numeric"  value={props.locationInput} autoFocus="auto" onKeyDown={props.checkLocationEnter} onChange={props.changeLocation}/>
</div>

<div className="col mt-4">
    <div className="btn btn-block btn-dark" onClick={props.selectLocation}>انتخاب لوکیشن </div>
</div>
</div> 
</div> 
            </React.Fragment>
        )
}
export default LocationForm;